import type { AuthorizationParams } from '@auth0/auth0-react'
const devFlag = process.env.NODE_ENV !== 'production'

export const ENV = {
  dev: devFlag
} as const

export const HOST = {
  API: devFlag ? 'http://localhost:8080' : 'https://visnu-cloud-api.visnu.io'
} as const

export const auth0 = {
  domain: 'visnu.jp.auth0.com',
  clientId: devFlag ? 'uS46uosoAzkWyVNCoMYaBbxwFJBIblS5' : 'e5tHKuKvbsMoGijD1FV3fyhRpvkgl0Nb',
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: 'https://visnu.jp.auth0.com/api/v2/'
  } satisfies AuthorizationParams
} as const

export const MAPBOX = {
  accessToken: 'pk.eyJ1IjoidmlzbnUtaW5jIiwiYSI6ImNsNngxdm12dTFyMW4zZW1zejZtdnF6cXIifQ.g96LxA4uGBpW_z2NA4Sbog',
  styleUrl: {
    light: 'mapbox://styles/visnu-inc/cl89r5e9a000914qj3c6us483',
    dark: 'mapbox://styles/visnu-inc/cl6xibrmg005014ro011oznh4'
  }
} as const
